import React, { Component } from 'react'
import NumberFormat from 'react-number-format'
import { getLocale } from '../../util/Localizer'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import { Colors } from '../../theme'

class PaidByOtherTextField extends Component {
  constructor () {
    super()

    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)

    this.state = {
      focused: false
    }
  }

  resetState () {
    // PaidByOtherTextField is now a controlled component and no longer
    // maintains internal state. `resetState` is a noop that has been
    // left in place to avoid breaking components that still call it.
    // From now on, reset PaidByOtherTextField by updating the `value`
    // and `error` props.
  }

  handleFocus () {
    this.setState({ focused: true })
  }

  handleBlur (e) {
    const value = e.target.value
      .replace(',', '.')
      .replace(/[^\d+|.]/g, '')

    const numericValue = Number(value)

    if (this.props.onBlur && !isNaN(numericValue)) {
      this.props.onBlur(numericValue)
    }

    this.setState({ focused: false })
  }

  handleChange (values) {
    const { value = 0 } = values
    if (typeof this.props.onValueChange === 'function') {
      this.props.onValueChange({ [this.props.id]: value })
    }
  }

  // needs work, currently not allowing users to go back
  render () {
    const { textLabel, maxValue, ...props } = this.props
    const rawValue = (this.props.value !== null && this.props.value !== undefined) ? this.props.value : ''
    const textProps = (getLocale() === 'en') ? { prefix: '$', decimalSeparator: '.' } : { suffix: ' $', decimalSeparator: ',' }
    const propValue = (getLocale() === 'en') ? rawValue : rawValue.toString().replace('.', ',')
    const error = !!this.props.error
    return (
      <FormControl fullWidth={props.fullWidth} >
        <InputLabel
          htmlFor="component-simple"
          shrink={this.props.floatinglabelfixed}
          style={Object.assign({}, { color: Colors.Palette.primaryTextColor }, this.props.labelStyles)}
          error={error}>{textLabel}</InputLabel>
        <NumberFormat
          ref={(input) => { this.paidByOther = input }}
          id={this.props.id}
          autoComplete={this.props.autoComplete}
          disabled={this.props.disabled}
          {...textProps}
          decimalScale={2}
          fixedDecimalScale={!this.state.focused}
          allowNegative={false}
          allowEmptyFormatting={this.props.allowEmptyFormatting}
          customInput={Input}
          value={propValue}
          margin={this.props.margin}
          onFocus={(e) => this.handleFocus(e)}
          onBlur={(e) => this.handleBlur(e)}
          onValueChange={(values) => this.handleChange(values)}
          style={this.props.styles}
        />
        <FormHelperText error={error}>{this.props.error && this.props.error !== 0 ? this.props.error : null}</FormHelperText>
      </FormControl>
    )
  }
}

export default PaidByOtherTextField



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/PaidByOtherTextField.js